import styles from './main-section-social-media.module.css'

function MainSectionSocialMedia() {
    return (
        <section className={styles.social}>
            <div className={styles.box}>
                <h2 className={styles.title}>Читайте нас в телеграме</h2>
                <div className={styles.buttons}>
                    <div className={styles.container}>
                        <a className={styles.href} target="_blank" href={'https://t.me/usamarke1'}>
                            <button className={styles.firstBtn}>
                                <div className={styles.logo}></div>
                                <span className={styles.textBtn}>Invest Era</span>
                            </button>
                        </a>
                        <span className={styles.text}>
                            Фундаментальные разборы компаний и экономической ситуации
                    </span>
                    </div>
                    <div className={styles.container}>
                        <a className={styles.href} target="_blank" href={'https://t.me/infousamarket'}>
                            <button className={styles.secondBtn}>
                                <div className={styles.logo}></div>
                                <span className={styles.textBtn}>99 СЛОВ</span>

                            </button>
                        </a>
                        <span className={styles.text}>
                            Новости экономики, финансов, недвижимости и фондового рынка
                    </span>
                    </div>
                    <div className={styles.container}>
                        <a className={styles.href} target="_blank" href={'https://t.me/AnalyticsUSARussiaMarkets'}>
                            <button className={styles.thirdBtn}>
                                <div className={styles.logo}></div>
                                <span className={styles.textBtn}>Era Media</span>

                            </button>
                        </a>
                        <span className={styles.text}>
                            Новости, которые повлияют на котировки компаний и рынок
                    </span>
                    </div>

                    <div className={styles.phones}></div>
                    <div className={styles.phone}></div>
                </div>
            </div>

        </section>
    )
}

export default MainSectionSocialMedia